import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@bibliocommons/base-buttons';
import { bindAll } from '@bibliocommons/utils-react';

export class DigitalReturnButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleOpen() {
    this.props.modalActions.openModal(this.props.modalKey, { accountRequired: true });
  }

  render() {
    return (
      <Button className="cp-digital-return-button" handleClick={this.handleOpen}>
        <FormattedMessage id="digital_return_now" />
      </Button>
    );
  }
}

DigitalReturnButton.propTypes = {
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalKey: PropTypes.string.isRequired
};

export default DigitalReturnButton;
